<app-data-block>
  <div blockHeader>
    <h2>{{ 'signup.details' | translate }}</h2>
    <p>{{ 'signup.detailsInfo' | translate }}</p>
  </div>

  <div class="contractor-intro__grid">
    @for (item of companyFields; track item.field) {
      <button class="contractor-intro__field"
        type="button"
        (click)="editField(item.field, item.labelKey)">
        <span>{{ item.labelKey | translate }}</span>
        <strong>{{ getFieldValue(item.field) }}</strong>
      </button>
    }
  </div>

  <div class="contractor-intro__description">
    <label>{{ 'intro.description' | translate }}</label>
    <ion-item lines="none">
      <ion-textarea rows="5"
        [(ngModel)]="contractor.description"></ion-textarea>
    </ion-item>
  </div>

  <div class="contractor-intro__actions">
    <ion-button color="light"
      (click)="save()">
      {{ 'general.save' | translate }}
    </ion-button>
  </div>
</app-data-block>

<app-data-block [compact]="true">
  <div blockHeader>
    <h2>{{ 'intro.services' | translate }}</h2>
    <ion-button color="light"
      (click)="addService()">
      {{ 'item.add' | translate }}
    </ion-button>
  </div>

  <div class="contractor-intro__chips">
    @for (service of contractor.services; track $index) {
      <span class="contractor-intro__chip">
        {{ service }}
      </span>
    } @empty {
      <p>{{ 'intro.noServices' | translate }}</p>
    }
  </div>
</app-data-block>
